// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","532":"styles"}[chunkId] + "-" + {"230":"1f8da6eec1aa3ea012fb","256":"9e30ab288834ec8d55f0","532":"26d16f0720d8bbebff9d"}[chunkId] + ".js";
};